/**
 * Created by mac on 7/23/25
 */

const LightningRushMerge2Adapter = {
    SubscribeToEvents: function () {
        cleverapps.missionManager.on("add", (mission) => {
            if (!Merge2.current) {
                return;
            }
            if (mission.getType() === Mission.TYPE_LIGHTNING_RUSH) {
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        cleverapps.missionManager.on("complete", (mission) => {
            if (mission.getType() === Mission.TYPE_LIGHTNING_RUSH) {
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        cleverapps.missionManager.on("lightningRushStateChanged", (mission) => {
            if (Merge2.current && mission.getType() === Mission.TYPE_LIGHTNING_RUSH) {
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        cleverapps.missionManager.on("lightningRushStart", (mission) => {
            if (mission.getType() === Mission.TYPE_LIGHTNING_RUSH) {
                mission.logic.startCompetition();
            }
        });
        
        cleverapps.eventBus.on("mapEvent", (type, options) => {
            if (type !== Field.MERGE && type !== Field.SPAWN) {
                return;
            }

            const mission = cleverapps.missionManager.findByType(Mission.TYPE_LIGHTNING_RUSH);

            const unit = options.unit;
            if (type === Field.SPAWN && Unit.Equals(LightningRushMerge2Adapter.TARGET_UNIT, options.unit)) {
                if (mission && mission.isRunning() && mission.logic.isActiveState()) {
                    mission.logic.earnPoints(1);
                    unit.onShowMissionMark(mission);
                }

                cleverapps.personalBest.addPoint("lightning", 1);
            }
        });
    }
};

LightningRushMerge2Adapter.TARGET_UNIT = {
    code: "e",
    stage: 3
};

cleverapps.whenAllInitialized(() => LightningRushMerge2Adapter.SubscribeToEvents());